import { Link } from "react-router-dom";
import { PageHero, useTitle } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { CTABand } from "../components/CTABand";
import { INDUSTRIES } from "../data/industries";
import { IMG } from "../data/site";

export default function Industries() {
  useTitle("Industries We Serve — Cement, Mining, Steel, Oil & Gas | SABAKT KSA");
  return (
    <main>
      <PageHero image={IMG.hero} eyebrow="Industries We Serve" testid="industries-hero"
        title="One Partner. Every Heavy Industry in the Kingdom." accent="Kingdom."
        text="Abrasion, impact, uptime, equipment life and maintenance cost — the physics are the same across industries. The solutions are specific to yours." />
      <section className="py-20 lg:py-28">
        <div className="mx-auto grid max-w-7xl gap-px border border-seam bg-seam px-0 sm:grid-cols-2 lg:grid-cols-3" style={{ margin: "0 auto", width: "calc(100% - 2rem)", maxWidth: "80rem" }}>
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.slug} delay={(i % 3) * 0.08}>
              <Link to={`/industries/${ind.slug}`} data-testid={`industries-card-${ind.slug}`}
                className="group relative block h-72 overflow-hidden bg-obsidian">
                <img src={ind.image} alt={ind.name} className="absolute inset-0 h-full w-full object-cover opacity-35 transition-all duration-700 group-hover:scale-105 group-hover:opacity-55" />
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/40 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-7">
                  <span className="font-mono text-xs text-spark">{String(i + 1).padStart(2, "0")}</span>
                  <h2 className="mt-1 font-display text-2xl font-extrabold uppercase tracking-tight text-frost group-hover:text-spark">{ind.name}</h2>
                  <p className="mt-2 line-clamp-2 text-sm text-cadmium">{ind.challenges[0]}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <CTABand title="Don't See Your Industry? Ask Anyway."
        text="If it wears, corrodes, carries load or moves material — we've likely fabricated it, protected it or rebuilt it. Send the requirement." />
    </main>
  );
}
